import React from "react";

interface AlertPopupProps {
  message: string;
  onClose: () => void;
}

const AlertPopup: React.FC<AlertPopupProps> = ({ message, onClose }) => {
  return (
    <div className="alertPopup">
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "none",
          border: "none",
          fontSize: "24px",
          cursor: "pointer",
          padding: "5px",
          lineHeight: "1",
          color: "white",
        }}
      >
        ×
      </button>
      <p style={{ marginTop: "1.5%", fontSize: "24px" }}>Attention</p>
      <p>{message}</p>
    </div>
  );
};

export default AlertPopup;
